export const AccountFilterElements = {
	accountFiltersId: 'accountFiltersId',
	allAccountCheckboxFilterId: 'allAccountCheckboxFilterId',
	individualsAccountCheckboxFilterId: 'individualsAccountCheckboxFilterId',
	plansAccountCheckboxFilterId: 'plansAccountCheckboxFilterId',
	groupsAccountCheckboxFilterId: 'groupsAccountCheckboxFilterId',
	linkedAccountCheckboxFilterId: 'linkedAccountCheckboxFilterId',
	closedAccountCheckboxFilterId: 'closedAccountCheckboxFilterId',
	postcodeFilterId: 'postcodeFilterId',
	minAgeFilterId: 'minAgeFilterId',
	maxAgeFilterId: 'maxAgeFilterId',
	ageErrorId: 'ageErrorId',
};
